
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, ResponsiveContainer } from 'recharts';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import ChartLegend from '@/components/charts/ChartLegend';

interface GatewayPerformanceChartProps {
  chartData: any[];
  hiddenLines: string[];
  onLegendClick: (dataKey: string) => void;
}

const GatewayPerformanceChart: React.FC<GatewayPerformanceChartProps> = ({
  chartData,
  hiddenLines,
  onLegendClick
}) => {
  // Custom legend renderer
  const renderLegend = (props: any) => {
    return (
      <ChartLegend 
        payload={props.payload} 
        hiddenLines={hiddenLines} 
        onLegendClick={onLegendClick}
      />
    );
  };

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Gateway Performance</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={chartData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis yAxisId="left" />
              <YAxis yAxisId="right" orientation="right" />
              <RechartsTooltip />
              <Line 
                yAxisId="left" 
                type="monotone" 
                dataKey="dataTransferred" 
                name="Data Transferred (MB)" 
                stroke="#3b82f6" 
                activeDot={{ r: 8 }} 
                hide={hiddenLines.includes('dataTransferred')}
              />
              <Line 
                yAxisId="right" 
                type="monotone" 
                dataKey="averageLatency" 
                name="Average Latency (ms)" 
                stroke="#f59e0b" 
                hide={hiddenLines.includes('averageLatency')}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default GatewayPerformanceChart;
